<template>
    <div>
      <guest :pageType="3"  :mingxi_type="mingxi_type"  :mingxiMain_type="mingxiMain_type"  v-if="mingxiMain_type === 1" user_type="2"> </guest> 
      <mendianList :pageType="4"  :mingxi_type="mingxi_type" :mingxiMain_type="mingxiMain_type" v-if="mingxiMain_type === 2"  caozuo_type="1"> </mendianList> 
    </div>
  </template>
  <script>
  import guest from './guest.vue'
  import mendianList from './mendian.vue';
  export default {
  
    components: {
        guest: guest,
        mendianList: mendianList
    },
  
    data() {
      return {
        // 获取用户列表参数
        
      };
    },
    props: ['pageType', 'mingxi_type', 'mingxiMain_type'], // 只需要传递参数 mingxi_type 即可
   
    watch: {
   
    },
    created() {
   
    },
    mounted() {
   
    }
  }
  </script>
